import { t } from '@sm/intl';

import {
  CORPOATE_SIGNATURE_RESEARCH_ENDPAGE_COPY,
  CX_ENDPAGE_COPY,
  GO_BEYOND_TEXT_BANNER_COPY,
  MRX_ENDPAGE_COPY,
  RACIAL_JUSTICE_ENDPAGE_COPY,
  FEATURED_EP_US_MAP_COPY,
  POLLING_TEXT_BANNER_COPY,
} from './copy';
import cxMaze from '~static/images/cx-maze.png';
import mrxShoe from '~static/images/mrx-shoe.png';
import researchReport from '~static/images/research-report.png';
import rjGroup from '~static/images/rj-group.png';
import USMap from '~static/images/us_political_map_large.png';
import { BackgroundColorProp } from '~app/components/TextBanner';

type PageProps = {
  imageSource: string;
  hasPrivacyNotice: boolean;
  hasShadedBackground: boolean;
  logoRoute: string;
  pageCTA: string;
  pageCTARoute?: string;
  pageHeading: string;
  pageSubheading?: string;
  privacyRoute: string;
  textBannerBackgroundColor: BackgroundColorProp;
  textBannerCTA: string;
  textBannerCTARoute: string;
  textBannerHeading?: string;
  textBannerSubheading: string;
  utSource2: string;
};

export type Page = {
  [key: string]: PageProps;
};

const Pages: Page = {
  CorporateSignatureResearchEndpage: {
    imageSource: researchReport,
    hasPrivacyNotice: false,
    hasShadedBackground: true,
    logoRoute: '/',
    pageCTA: t(CORPOATE_SIGNATURE_RESEARCH_ENDPAGE_COPY.PAGE_CTA_TEXT),
    // @todo https://momentiveai.atlassian.net/browse/ANONWEB-5440
    // Before these pages are exposed to non-english locales we will need to localize URLs to some CMS website, see ticket.
    pageCTARoute: '/mp/2020-research-report/',
    pageHeading: t(CORPOATE_SIGNATURE_RESEARCH_ENDPAGE_COPY.PAGE_HEADING),
    pageSubheading: t(CORPOATE_SIGNATURE_RESEARCH_ENDPAGE_COPY.PAGE_SUBHEADING),
    privacyRoute: '',
    textBannerBackgroundColor: 'dark1',
    textBannerCTA: t(GO_BEYOND_TEXT_BANNER_COPY.CTA_TEXT),
    textBannerCTARoute: 'https://www.momentive.ai/en/',
    textBannerHeading: t(GO_BEYOND_TEXT_BANNER_COPY.HEADING),
    textBannerSubheading: t(GO_BEYOND_TEXT_BANNER_COPY.SUBHEADING),
    utSource2: 'CorporateSignatureResearchEndpage',
  },
  CxEndpage: {
    imageSource: cxMaze,
    hasPrivacyNotice: false,
    hasShadedBackground: true,
    logoRoute: '/',
    pageCTA: t(CX_ENDPAGE_COPY.PAGE_CTA_TEXT),
    pageCTARoute: 'https://www.getfeedback.com/en/start/',
    pageHeading: t(CX_ENDPAGE_COPY.PAGE_HEADING),
    pageSubheading: t(CX_ENDPAGE_COPY.PAGE_SUBHEADING),
    privacyRoute: '',
    textBannerBackgroundColor: 'dark1',
    textBannerCTA: t(GO_BEYOND_TEXT_BANNER_COPY.CTA_TEXT),
    textBannerCTARoute: 'https://www.momentive.ai/en/',
    textBannerHeading: t(GO_BEYOND_TEXT_BANNER_COPY.HEADING),
    textBannerSubheading: t(GO_BEYOND_TEXT_BANNER_COPY.SUBHEADING),
    utSource2: 'CxEndpage',
  },
  FeaturedEpUSMap: {
    imageSource: USMap,
    hasPrivacyNotice: true,
    hasShadedBackground: true,
    logoRoute: '/',
    pageCTA: t(FEATURED_EP_US_MAP_COPY.PAGE_CTA_TEXT),
    // @todo https://momentiveai.atlassian.net/browse/ANONWEB-5440
    // Before these pages are exposed to non-english locales we will need to localize URLs to some CMS website, see ticket.
    pageHeading: t(FEATURED_EP_US_MAP_COPY.PAGE_HEADING),
    privacyRoute: '/mp/legal/survey-research-privacy-notice/',
    textBannerBackgroundColor: 'dark2',
    textBannerCTA: t(POLLING_TEXT_BANNER_COPY.CTA_TEXT),
    textBannerCTARoute: '/user/sign-up/',
    textBannerSubheading: t(POLLING_TEXT_BANNER_COPY.SUBHEADING),
    utSource2: 'FeaturedEpUSMap',
  },
  MrxEndpage: {
    imageSource: mrxShoe,
    hasPrivacyNotice: false,
    hasShadedBackground: true,
    logoRoute: '/',
    pageCTA: t(MRX_ENDPAGE_COPY.PAGE_CTA_TEXT),
    pageCTARoute: '/curiosity/how-allbirds-uses-surveymonkey-audience-to-fuel-its-explosive-brand-growth/',
    pageHeading: t(MRX_ENDPAGE_COPY.PAGE_HEADING),
    pageSubheading: t(MRX_ENDPAGE_COPY.PAGE_SUBHEADING),
    privacyRoute: '',
    textBannerBackgroundColor: 'dark1',
    textBannerCTA: t(GO_BEYOND_TEXT_BANNER_COPY.CTA_TEXT),
    textBannerCTARoute: 'https://www.momentive.ai/en/',
    textBannerHeading: t(GO_BEYOND_TEXT_BANNER_COPY.HEADING),
    textBannerSubheading: t(GO_BEYOND_TEXT_BANNER_COPY.SUBHEADING),
    utSource2: 'MrxEndpage',
  },
  RacialJusticeEndpage: {
    imageSource: rjGroup,
    hasPrivacyNotice: false,
    hasShadedBackground: true,
    logoRoute: '/',
    pageCTA: t(RACIAL_JUSTICE_ENDPAGE_COPY.PAGE_CTA_TEXT),
    pageCTARoute: '/mp/workforce-racial-equity/',
    pageHeading: t(RACIAL_JUSTICE_ENDPAGE_COPY.PAGE_HEADING),
    pageSubheading: t(RACIAL_JUSTICE_ENDPAGE_COPY.PAGE_SUBHEADING),
    privacyRoute: '',
    textBannerBackgroundColor: 'dark1',
    textBannerCTA: t(GO_BEYOND_TEXT_BANNER_COPY.CTA_TEXT),
    textBannerCTARoute: 'https://www.momentive.ai/en/',
    textBannerHeading: t(GO_BEYOND_TEXT_BANNER_COPY.HEADING),
    textBannerSubheading: t(GO_BEYOND_TEXT_BANNER_COPY.SUBHEADING),
    utSource2: 'RacialJusticeEndpage',
  },
};

export default Pages;
